import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Toolbar from '@mui/material/Toolbar';
import { Suspense, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { NAV_ITEMS } from './navConfig';
import { ShellProvider } from './ShellContext';
import SidePanel, { SIDEBAR_WIDTH } from './SidePanel';
import ToolErrorBoundary from './ToolErrorBoundary';
import TopBar from './TopBar';
const ShellLayoutInner = ({ title, topBarCenterSlot, topBarEndSlot, sideBarBottomSlot }) => {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const { pathname } = useLocation();
    return (_jsxs(Box, { sx: { display: 'flex', minHeight: '100vh' }, children: [_jsx(TopBar, { sidebarOpen: sidebarOpen, onSidebarToggle: () => setSidebarOpen((prev) => !prev), title: title, centerSlot: topBarCenterSlot, endSlot: topBarEndSlot }), _jsx(SidePanel, { open: sidebarOpen, onClose: () => setSidebarOpen(false), bottomSlot: sideBarBottomSlot }), _jsxs(Box, { component: "main", sx: {
                    flexGrow: 1,
                    p: 3,
                    transition: (theme) => theme.transitions.create('margin', {
                        easing: theme.transitions.easing.sharp,
                        duration: sidebarOpen
                            ? theme.transitions.duration.enteringScreen
                            : theme.transitions.duration.leavingScreen
                    }),
                    ml: sidebarOpen ? 0 : `-${SIDEBAR_WIDTH}px`
                }, children: [_jsx(Toolbar, {}), _jsx(ToolErrorBoundary, { children: _jsx(Suspense, { fallback: _jsx(Box, { sx: { display: 'flex', justifyContent: 'center', pt: 8 }, children: _jsx(CircularProgress, {}) }), children: _jsx(Outlet, {}) }) }, pathname)] })] }));
};
/**
 * ShellLayout is a React Router layout route — it renders once and persists
 * across navigation between authenticated child routes via <Outlet />.
 * All nav items are pre-seeded from navConfig so the sidebar is always complete.
 */
const ShellLayout = ({ initialItems, ...rest }) => (_jsx(ShellProvider, { initialItems: initialItems ?? NAV_ITEMS, children: _jsx(ShellLayoutInner, { ...rest }) }));
export default ShellLayout;
